module.exports = __webpack_public_path__ + "static/img/JsecureColorTif.340dc84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/JsecureColorTif.jpg
// module id = 2oNR
// module chunks = 1